// Shared staff-side vendor lifecycle vocabulary.
//
// V2c shipped a local STAFF_EVENT_COPY inside JobDetail.tsx for the
// staff-side timeline. V2e surfaces the same five states on FieldHub
// JobCards too — extracting the map to a shared lib keeps the chip
// visuals consistent and avoids drift. The vendor side keeps its own
// EVENT_COPY in VendorJobDetail because it carries different
// affordances (buttons + dialogs); those stay vendor-local.
//
// Pure data + a typed StaffLifecycleEvent literal — no React.

export type StaffLifecycleEvent =
  | 'en_route'
  | 'on_site'
  | 'delayed'
  | 'return_visit_scheduled'
  | 'completed'

export interface LifecycleVisual {
  label: string
  bg: string
  border: string
  color: string
}

export const STAFF_EVENT_COPY: Record<StaffLifecycleEvent, LifecycleVisual> = {
  en_route:               { label: 'En route',     bg: 'var(--info-dim)',     border: 'var(--info-border)',     color: 'var(--info)' },
  on_site:                { label: 'On site',      bg: 'var(--info-dim)',     border: 'var(--info-border)',     color: 'var(--info)' },
  delayed:                { label: 'Delayed',      bg: 'var(--warning-dim)',  border: 'var(--warning-border)',  color: 'var(--warning)' },
  return_visit_scheduled: { label: 'Return visit', bg: 'var(--accent-dim)',   border: 'var(--accent-border)',   color: 'var(--accent-text)' },
  completed:              { label: 'Complete',     bg: 'var(--positive-dim)', border: 'var(--positive-border)', color: 'var(--positive)' },
}
